export enum Voltage {
  LV = 1,
  MV = 2,
  HV = 3
}